import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        // <footer className="bg-slate-50 border-t border-slate-200 py-20 px-6 lg:px-8">
        //     <div className="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        //         <div className="space-y-6">
        //             <div className="flex items-center gap-2">
        //                 <div className="text-primary">
        //                     <svg className="size-6" fill="currentColor" viewBox="0 0 48 48">
        //                         <path
        //                             clipRule="evenodd"
        //                             d="M24 4H6V17.3333V30.6667H24V44H42V30.6667V17.3333H24V4Z"
        //                             fillRule="evenodd"
        //                         />
        //                     </svg>
        //                 </div>
        //                 <h2 className="text-lg font-bold text-primary">EliteTutor</h2>
        //             </div>
        //             <p className="text-sm text-slate-500 leading-relaxed">
        //                 Connecting ambitious students with the world's finest educators to
        //                 foster authentic learning and growth.
        //             </p>
        //         </div>
        //         <div>
        //             <h4 className="font-bold text-slate-900 mb-6">Platform</h4>
        //             <ul className="space-y-4 text-sm text-slate-600">
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Find a Tutor
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Become a Tutor
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Group Classes
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Pricing
        //                     </a>
        //                 </li>
        //             </ul>
        //         </div>
        //         <div>
        //             <h4 className="font-bold text-slate-900 mb-6">Company</h4>
        //             <ul className="space-y-4 text-sm text-slate-600">
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         About Us
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Careers
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Safety
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a className="hover:text-primary transition-colors" href="#">
        //                         Privacy Policy
        //                     </a>
        //                 </li>
        //             </ul>
        //         </div>
        //         <div className="space-y-6">
        //             <h4 className="font-bold text-slate-900">Stay Updated</h4>
        //             <div className="flex gap-2">
        //                 <input
        //                     className="w-full rounded-full border-slate-200 bg-white px-4 py-2 text-sm focus:border-primary focus:ring-primary"
        //                     placeholder="Email address"
        //                     type="email"
        //                 />
        //                 <button className="rounded-full bg-primary px-4 py-2 text-white hover:bg-primary-hover">
        //                     <span className="material-symbols-outlined text-sm">send</span>
        //                 </button>
        //             </div>
        //         </div>
        //     </div>
        //     <div className="mx-auto max-w-7xl mt-16 pt-8 border-t border-slate-200 text-center">
        //         <p className="text-xs text-slate-400">
        //             © 2024 EliteTutor. All rights reserved.
        //         </p>
        //     </div>
        // </footer>

        <footer className="bg-white dark:bg-background-dark border-t border-[#e7f3ee] dark:border-white/10 py-12">
            <div className="max-w-[960px] mx-auto px-4 flex flex-col md:flex-row justify-between gap-8 items-center">
                <div className="flex items-center gap-2 text-primary">
                    <div className="size-10">
                        <Link to="/">
                            <img src={process.env.PUBLIC_URL + "/favicon.svg"} alt='img'/>
                        </Link>
                    </div>
                    <span className="font-bold text-[#0d1b15] dark:text-white">
                        Tutor Match AE
                    </span>
                </div>
                <div className="flex gap-8 text-sm font-medium text-[#4c9a78]">
                    <Link className="hover:text-primary transition-colors" to="/about">
                        About
                    </Link>
                    <Link className="hover:text-primary transition-colors" to="/privacy">
                        Privacy
                    </Link>
                    <Link className="hover:text-primary transition-colors" to="/terms">
                        Terms
                    </Link>
                    <Link className="hover:text-primary transition-colors" to="/contact">
                        Contact
                    </Link>
                </div>
                <div className="text-sm text-[#4c9a78]">
                    © {new Date().getFullYear()} Tutor Match AE. All rights reserved.
                </div>
            </div>
        </footer>
    )
}

export default Footer